import React from 'react';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Table, Label, ModalBody, ModalFooter, Row, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import Select from 'react-select';
import './StyleExamCreateMicrobiology.css';


export const CreateExamMicrobiology = (props) => {

    const {
        formValues, examId, methodExam, closeDialog, handleInputChange, handleSelectValues, handleChangePrice, validaciones, loading,
        sections, changeSelect, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports, formats,
        cost,
        methodAction, isSimple = false, isImagenology = false, use_antibiogram,
        infoEdit = {}, examEditId, isImagenologyy, print_new_page
    } = props;

    const {
        code: validationCode,
        alias: validationAlias,
        name: validationName,
        abbreviation: validationAbbreviation,
        id_section: validationSection,
        id_specimen: validationSpecimen,
        id_specimen_provenance: validateSpecimenProvenance,
        delivery_time: validateDeliveryTime,
        list_transports: validationListTransports,
        id_format_sanitary: validationFormat
    } = validaciones;

    const {
        code
    } = formValues;

    const handleSelectSection = (value, fieldName) => {
 
        formValues[fieldName] = value;
    };




    const txtsection = localStorage.getItem('TextAS');

    const sectionOptions = sections.map(s => ({
        value: s.id_section,
        label: s.name
    }));

    const formatOptions = formats.map(s => ({
        value: s.id_format_sanitary,
        label: s.descripcion
    }));


    return (
        <Form onSubmit={methodAction} >
            <Row>
                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Clave <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.code}
                        type="text"
                        name="code"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationCode}
                    />
                    <FormFeedback>El codigo debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Alias <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.alias}
                        //  placeholder="Ingresa el alias"
                        type="text"
                        name="alias"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAlias}
                    />
                    <FormFeedback>El alias debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Abreviatura <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.abbreviation}
                        //placeholder="Ingresa la abreviatura"
                        type="text"
                        name="abbreviation"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAbbreviation}
                    />
                    <FormFeedback>La abreviatura debe tener 2 o más caracteres</FormFeedback>
                </FormGroup>
            </Row>
            <Row>
                <FormGroup className="mb-3 col-6">
                    <Label className='labelInfoAnalyte'>Nombre del exámen<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.name}
                        // placeholder="Ingresa el nombre del exámen"
                        type="text"
                        name="name"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationName}
                    />
                    <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-6">
                    <Label className='labelInfoAnalyte'>Tiempo de entrega<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.delivery_time}
                        type="text"
                        name="delivery_time"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validateDeliveryTime}
                        
                    />
                    <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                
            </Row>
            <Row>

            </Row>
            <Row>
                {/* <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>{txtsection} <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.id_section}
                        type="select"
                        name="id_section"
                        required={true}
                        onChange={changeSelect}
                        invalid={validationSection}
                    >
                        <option value="0">Selecciona una opción</option>
                        {
                            sections.length > 0 && sections.map((s, key) => {
                                return <option key={key} value={s.id_section}>
                                    {s.name}
                                </option>
                            })
                        }
                    </Input>

                </FormGroup> */}

                 <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>{txtsection} <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Select
                        name="id_section"
                        options={sectionOptions}
                        value={sectionOptions.find(
                            opt => String(opt.value) === String(formValues.id_section)
                        )}
                        onChange={(e) => handleSelectSection(e.value, "id_section")}
                        isClearable={false}
                        classNamePrefix="select"
                        className={validationSection ? "is-invalid" : ""}
                        placeholder="Seleccione una sección"
                    />
                    {validationSection && (
                        <div className="invalid-feedback d-block">
                            Debes seleccionar al menos una opción
                        </div>
                    )}
                    
                </FormGroup>
                 <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>
                        Tipo de muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span>
                    </Label>

                    <Select
                        value={formValues.id_specimen}
                        classNamePrefix="select"
                        name="id_specimen"
                        placeholder="Selección de espécimen"
                        options={specimens}
                        isClearable={false}
                        noOptionsMessage={() => "Sin opciones"}
                        onChange={(e) => handleSelectValues(e, "id_specimen")}
                        className={validationSpecimen ? "is-invalid" : ""}
                        required={true}
                    />

                    {validationSpecimen && (
                        <div className="invalid-feedback d-block">
                            Debes seleccionar al menos una opción
                        </div>
                    )}
                </FormGroup>

                <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Procedencia de la muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    {/* specimenProvenances */}
                    <Select
                        value={formValues.id_specimen_provenance}
                        classNamePrefix="select"
                        name="id_specimen_provenance"
                        placeholder={`Seleciona la procedencia`}
                        isClearable={false}
                        noOptionsMessage={() => "Sin opciones"}
                        options={specimenProvenances}
                        onChange={(e) => handleSelectValues(e, "id_specimen_provenance")}
                        className={validateSpecimenProvenance ? "is-invalid" : ""}
                        required={true}
                    />

                    {validateSpecimenProvenance && (
                        <div className='invalid-feedback d-block'>
                             Debes seleccionar al menos una procedencia
                        </div>
                    )}

                </FormGroup>
              
                <FormGroup className="mb-3 col-8">
                    <Label className='labelInfoAnalyte'>Medio(s) de transporte <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Select
                        value={formValues.list_transports}
                        isMulti
                        classNamePrefix="select"
                        name="list_transports"
                        onChange={(e) => handleSelectValues(e, "list_transports")}
                        // value={valuePeriod}
                        placeholder={`Selección de medio de transporte`}
                        isClearable={false}
                        noOptionsMessage={() => "Sin opciones"}
                        options={transports}
                        required={true}

                    />
                    {validationListTransports && (
                        <div className="invalid-feedback d-block">
                            Debes seleccionar al menos un medio de trasporte
                        </div>
                    )}                
                </FormGroup>
                 <FormGroup className="mb-3 col-4">
                    <Label className='labelInfoAnalyte'>Diseño de impresión <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>                   
                    <Select
                        name="id_format_sanitary"
                        options={formatOptions}
                        value={formatOptions.find(
                            opt => String(opt.value) === String(formValues.id_format_sanitary)
                        )}
                        onChange={(e) => handleSelectSection(e.value, "id_format_sanitary")}
                        isClearable={false}
                        classNamePrefix="select"
                        placeholder="Seleccione un diseño"
                    />

                    {validationFormat && (
                        <div className="invalid-feedback d-block">
                            Debes seleccionar un diseño de impresión
                        </div>
                    )}     

                </FormGroup>
            </Row> <br />
            <Row style={{ textAlign: "-webkit-center" }}>
                {/* individual_sale: true
            is_critic: false
            is_referenced: false */}

                <FormGroup className="mb-3 col-2">
                    <Label>Venta individual</Label>
                    <br />
                    <Label className="switch">
                        <Input type="checkbox" checked={formValues.individual_sale} name="individual_sale" onChange={handleInputChange} />
                        <span className="slider round"></span>
                    </Label>
                </FormGroup>
                <FormGroup className="mb-3 col-2">
                    <Label>¿Es referenciado?</Label>
                    <br />
                    <Label className="switch">
                        <Input type="checkbox" checked={formValues.is_referenced} name="is_referenced" onChange={handleInputChange} />
                        <span className="slider round"></span>
                    </Label>
                </FormGroup>
                <FormGroup className="mb-3 col-2">
                    <Label>¿Es critico?</Label>
                    <br />
                    <Label className="switch">
                        <Input type="checkbox" checked={formValues.is_critic} name="is_critic" onChange={handleInputChange} />
                        <span className="slider round"></span>
                    </Label>
                </FormGroup>
                <FormGroup className="mb-3 col-3">
                    <Label>¿usa antibiograma?</Label>
                    <br />
                    <Label className="switch">
                        <Input type="checkbox" name="use_antibiogram" checked={formValues.use_antibiogram} onChange={handleInputChange} />
                        <span className="slider round"></span>
                    </Label>
                </FormGroup>

                <FormGroup className="mb-3 col-3">
                    <Label>¿Impresión en una hoja diferente?</Label>
                    <br />
                    <Label className="switch">
                        <Input type="checkbox" name="print_new_page" checked={formValues.print_new_page} onChange={handleInputChange} />
                        <span className="slider round"></span>
                    </Label>
                </FormGroup>

               

            </Row>

            {
                examId > 0 ?
                    "" :
                    <>
                        <Row>

                            <Col md="6">
                                <Label>Precio inicial</Label>
                                <Table className="table table-bordered table-sm">
                                    <tbody>
                                        {
                                            commercialLines.length >= 1 && commercialLines.map((data, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td className='bg-secondary' >{data.short_name}</td>
                                                        <td className='bg-secondary' >
                                                            <InputGroup className="">
                                                                <Input
                                                                    type="number"
                                                                    name="price_commercial_line"
                                                                    onChange={handleChangePrice}
                                                                    className="form-control"
                                                                    data-id={key} step="any" placeholder="Precio inicial" />
                                                                <InputGroupAddon addonType="append"><InputGroupText>{"$"}</InputGroupText></InputGroupAddon>
                                                            </InputGroup>

                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </Col>

                            <Col sm="3">
                                {
                                    examId > 0 ? "" :
                                        <>
                                            <Row>
                                                <FormGroup className="mb-2 col-11 mb-3">
                                                    <Label>Costo de producción</Label>
                                                    <InputGroup className="">
                                                        <Input type="number" min={0} className="form-control" name="cost" value={cost} onChange={handleInputChange} />
                                                        <InputGroupAddon addonType="append"><InputGroupText>{"$"}</InputGroupText></InputGroupAddon>
                                                    </InputGroup>
                                                    
                                                </FormGroup>
                                            </Row>
                                        </>
                                }
                            </Col>
                        </Row>

                    </>
            }
            <Input type='hidden' value={isSimple} name="is_simple" />
            <Input type='hidden' value={isImagenology} name="isImagenology" />

            <ModalFooter>
                {
                    isSimple || isImagenology ?
                        <Button
                            color="primary"
                            type="submit"
                            className={`${(examId > 0 && examEditId === undefined) ? "d-none " : ""} ${loading ? "disabled progress-bar-animated progress-bar-striped" : ""}`}
                        >
                            {examEditId === undefined ? "Guardar" : "Actualizar"}
                        </Button>
                        : <Button
                            color="primary"
                            type="submit"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                            Guardar
                        </Button>
                }

                {
                    !isSimple &&
                    <Button size="sm" className="btn-air-light" color="danger" type="button" onClick={closeDialog}>Cancelar</Button>
                }
            </ModalFooter>
        </Form >
    )
}
